/**
 * requestText.js — how the search box treats Request text (issue #22).
 *
 * Pure helpers, kept apart from the components so the routing rule and the
 * length cap are easy to tune and test.
 */

/** Text with more words than this is analysed rather than searched as is. Tunable. */
export const ANALYSE_WORD_THRESHOLD = 12;

/** Mirrors backend MAX_REQUEST_TEXT_CHARS (backend/requestText.js) — keep in sync. Measured on the raw string `.length`, as the backend does. */
export const MAX_REQUEST_TEXT_CHARS = 20000;

export const REQUEST_TEXT_TOO_LONG_MESSAGE =
  "This is too long to paste here. Upload it as a document instead.";

/**
 * True when the text should go to the analysis endpoint: it spans more than one
 * line, or has more than ANALYSE_WORD_THRESHOLD words. Anything else is a plain
 * query for /api/search.
 */
export function shouldAnalyse(text) {
  const trimmed = typeof text === "string" ? text.trim() : "";
  if (!trimmed) return false;
  if (/[\r\n]/.test(trimmed)) return true;
  return trimmed.split(/\s+/).length > ANALYSE_WORD_THRESHOLD;
}

export function isOverRequestTextLimit(text) {
  return typeof text === "string" && text.length > MAX_REQUEST_TEXT_CHARS;
}
